import DateSegment from "./DateSegment.js";
import React from "react";
import { jsx } from "react/jsx-runtime";
import { useDateField, useLocale } from "react-aria";
import { useDateFieldState } from "react-stately";
import { createCalendar } from "@internationalized/date";
//#region src/DatePicker/components/DateField.tsx
const DateField = (props) => {
	const { locale } = useLocale();
	const rootRef = React.useRef(null);
	const state = useDateFieldState({
		...props,
		locale,
		shouldForceLeadingZeros: true,
		createCalendar
	});
	const { fieldProps } = useDateField(props, state, rootRef);
	const onFocus = (ev) => {
		props.onFieldFocus?.(ev);
		fieldProps.onFocus?.(ev);
	};
	return /* @__PURE__ */ jsx("div", {
		...fieldProps,
		onFocus,
		ref: rootRef,
		className: "flex",
		children: state.segments.map((segment, i) => /* @__PURE__ */ jsx(DateSegment, {
			segment,
			state,
			size: props.size,
			onClick: onFocus
		}, `segment-${i}}`))
	});
};
//#endregion
export { DateField as default };

//# sourceMappingURL=DateField.js.map